import React from "react";
import { Card, CardMedia, Typography, Box } from "@mui/material";

const CustomTraceabilityDashboardCard = ({
  image,
  farmName,
  cropName,
  date,
  onClick,
}) => {
  return (
    <Card
      sx={{
        display: "flex",
        marginTop: "20px",
        borderRadius: "10px",
        boxShadow: "1px 6px 8px 0px #CCCCCC40",
        padding: "10px",
      }}
      onClick={onClick}
    >
      <CardMedia
        sx={{
          width: 60,
          height: 60,
          padding: "10px",
          borderRadius: "4px",
        }}
        image={image}
        alt={`${cropName} image`}
      />
      <Box
        sx={{
          marginLeft: "15px",
          width: "65%",
        }}
      >
        <div
          style={{
            width: "100%",
          }}
        >
          <Typography component="div" variant="h6" align="left">
            {farmName}
          </Typography>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              padding: "25px 0 0 0",
            }}
          >
            <Typography sx={{ textAlign: "left", fontSize: "15px" }}>
              Crop: {cropName}
            </Typography>
            <Typography sx={{ textAlign: "right", fontSize: "15px" }}>
              {date}
            </Typography>
          </Box>
        </div>
      </Box>
    </Card>
  );
};

export default CustomTraceabilityDashboardCard;
